import script from "./BlueDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueDropdown.vue?vue&type=script&setup=true&lang=js"

import "./BlueDropdown.vue?vue&type=style&index=0&id=cf983ea2&lang=css"

const __exports__ = script;

export default __exports__